import React, { useEffect, useState } from 'react';
import VendorInfo from './VendorInfo';
import VendorContact from './VendorContact';
import { fetchWithCorpId } from '../utils/api';
import { useParams } from 'react-router-dom';

function VendorForm({ mode = 'create', initialData = {}, onSuccess, onCancel }) {
  const { id } = useParams();
  const isEdit = mode === 'edit';
  const [activeTab, setActiveTab] = useState('info');
  const [vendor, setVendor] = useState({
    name: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    status: '',
    startDate: '',
    invoiced: false,
    contacts: [],
  });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchVendor = async () => {
      if (isEdit && id) {
        setLoading(true);
        try {
          const data = await fetchWithCorpId(`/vendors/${id}`);
          setVendor(data);
        } catch (error) {
          console.error('Error fetching vendor:', error);
          setMessage('❌ Error loading vendor data: ' + error.message);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchVendor();
  }, [isEdit, id]);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    let nextValue = type === 'checkbox' ? Boolean(checked) : value;
    if (name === 'invoiced' && type !== 'checkbox') {
      nextValue = value === 'true';
    }
    setVendor((prev) => ({ ...prev, [name]: nextValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    
    try {
      const url = isEdit && vendor.id
        ? `/vendors/${vendor.id}`
        : '/vendors';

      const response = await fetchWithCorpId(url, {
        method: isEdit ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(vendor),
      });

      if (response) {
        onSuccess();
      } else {
        setMessage('❌ Failed to save: Unknown error');
      }
    } catch (error) {
      setMessage('❌ Error: ' + error.message);
    }
  };

  const tabStyle = (tab) => ({
    padding: '10px 20px',
    cursor: 'pointer',
    backgroundColor: activeTab === tab ? '#f0f8ff' : '#f9f9f9',
    borderBottom: activeTab === tab ? '2px solid #28a745' : '1px solid #ccc',
    fontWeight: activeTab === tab ? 'bold' : 'normal',
  });

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: '700px', marginTop: '20px' }}>
      {message && (
        <div style={{ 
          marginBottom: '12px', 
          padding: '8px', 
          borderRadius: '4px',
          backgroundColor: message.includes('✅') ? '#d4edda' : '#f8d7da',
          color: message.includes('✅') ? '#155724' : '#721c24'
        }}>
          {message}
        </div>
      )}

      <div style={{ display: 'flex', gap: '12px', borderBottom: '1px solid #ccc' }}>
        <div style={tabStyle('info')} onClick={() => setActiveTab('info')}>Info</div>
        <div style={tabStyle('contact')} onClick={() => setActiveTab('contact')}>Contact</div>
      </div>

      <div style={{ padding: '12px' }}>
        {activeTab === 'info' && (
          <VendorInfo vendor={vendor} handleChange={handleChange} />
        )}
        {activeTab === 'contact' && (
          <VendorContact
            contacts={vendor.contacts}
            setContacts={(updatedContacts) => setVendor(prev => ({ ...prev, contacts: updatedContacts }))}
          />
        )}
      </div>

      <div style={{ marginTop: '12px', display: 'flex', gap: '10px' }}>
        <button 
          type="submit" 
          style={{ 
            padding: '10px 20px',
            height: '40px',
            backgroundColor: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            minWidth: '120px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 0
          }}
        >
          Save
        </button>
        {onCancel && (
          <button 
            type="button" 
            onClick={onCancel} 
            style={{ 
              padding: '10px 20px',
              height: '40px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              minWidth: '120px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: 0
            }}
          >
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}

export default VendorForm;
